// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"ca37552b","413":"b4a75dfa"}[chunkId] + ".chunk.js";
};